import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import API_BASE_URL from "../../config";
import "./Traceroute.css";

const Traceroute = () => {
  const { t } = useTranslation();

  const [target, setTarget] = useState("");
  const [loading, setLoading] = useState(false);
  const [hops, setHops] = useState([]);
  const [status, setStatus] = useState("");

  const eventSourceRef = useRef(null);

  // -----------------------------
  // START TRACEROUTE
  // -----------------------------
  const handleStart = () => {
    if (!target.trim()) return;

    setHops([]);
    setStatus("Starting...");
    setLoading(true);

    // close old stream
    if (eventSourceRef.current) {
      eventSourceRef.current.close();
    }

    const url = `${API_BASE_URL}/diagnostic-tools/traceroute?target=${encodeURIComponent(target)}`;

    const es = new EventSource(url);
    eventSourceRef.current = es;

    es.onopen = () => {
      setStatus("Connected...");
    };

    es.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);

        if (data.error) {
          setStatus(data.error);
          setLoading(false);
          es.close();
          return;
        }

        setHops((prev) => [...prev, data]);

      } catch (err) {
        console.error("Parse error:", err);
      }
    };

    es.onerror = () => {
      setStatus("Connection closed");
      setLoading(false);
      es.close();
    };
  };

  // -----------------------------
  // STOP STREAM
  // -----------------------------
  const handleStop = () => {
    if (eventSourceRef.current) {
      eventSourceRef.current.close();
    }
    setLoading(false);
    setStatus("Stopped");
  };

  // -----------------------------
  // CLEAR
  // -----------------------------
  const handleClear = () => {
    handleStop();
    setHops([]);
    setTarget("");
    setStatus("");
  };

  return (
    <div className="trace-container">

      <h2 className="trace-title">
        🌐 Live Traceroute Monitor
      </h2>

      {/* INPUT AREA */}
      <div className="trace-input-area">

        <input
          type="text"
          value={target}
          onChange={(e) => setTarget(e.target.value)}
          placeholder="Enter IP or Domain (e.g. google.com)"
          className="trace-input"
        />

        <button className="btn start" onClick={handleStart}>
          Start
        </button>

        <button className="btn stop" onClick={handleStop}>
          Stop
        </button>

        <button className="btn clear" onClick={handleClear}>
          Clear
        </button>

      </div>

      {/* STATUS */}
      <div className="trace-status">
        {status}
      </div>

      {/* RESULTS */}
      <div className="trace-output">

        {hops.map((hop, index) => (
          <div key={index} className="hop-card">

            <div className="hop-left">
              <span className="hop-index">#{hop.hop}</span>
              <span className="hop-ip">{hop.ip}</span>
            </div>

            <div className="hop-right">
              <span className="latency">
                {hop.latency} ms
              </span>

              <span className="resolved">
                {hop.resolved_ip ? `→ ${hop.resolved_ip}` : ""}
              </span>

              <span className="ipv">
                IPv{hop.ipv}
              </span>
            </div>

          </div>
        ))}

      </div>

    </div>
  );
};

export default Traceroute;